import { Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import { ReactComponent as ImageImple } from '@/svg/landing/sc3_implementation.svg'
import { ReactComponent as ImageAdvis } from '@/svg/landing/sc3_advisory.svg'
import { ReactComponent as ImageTraining } from '@/svg/landing/sc3_training.svg'
import { ReactComponent as ImageCompliance } from '@/svg/landing/sc3_compliance.svg'
import { ReactComponent as ImageLegal } from '@/svg/landing/sc3_legal.svg'

import { SummaryProps } from '@/features/aboutUs/components/OurServices/Summary'

const paragraphStyle = {
  fontSize: 'lg',
}

export const useServiceData = (): SummaryProps[] => {
  const { t } = useTranslation('aboutUs')

  return [
    {
      title: t('aboutUs.services.implementation.title'),
      image: <ImageImple />,
      Paragraph: (): React.ReactElement => (
        <Text sx={paragraphStyle}>
          {t('aboutUs.services.implementation.paragraph')}
        </Text>
      ),
    },
    {
      title: t('aboutUs.services.advisory.title'),
      image: <ImageAdvis />,
      Paragraph: (): React.ReactElement => (
        <Text sx={paragraphStyle}>
          {t('aboutUs.services.advisory.paragraph')}
          PDPA
        </Text>
      ),
    },
    {
      title: t('aboutUs.services.training.title'),
      image: <ImageTraining />,
      Paragraph: (): React.ReactElement => (
        <Text sx={paragraphStyle}>
          {t('aboutUs.services.training.paragraph')}
        </Text>
      ),
    },
    {
      title: t('aboutUs.services.compliance.title'),
      image: <ImageCompliance />,
      Paragraph: (): React.ReactElement => (
        <Text sx={paragraphStyle}>
          {t('aboutUs.services.compliance.paragraph')}
        </Text>
      ),
    },
    {
      title: t('aboutUs.services.legal.title'),
      image: <ImageLegal />,
      Paragraph: (): React.ReactElement => (
        <Text sx={paragraphStyle}>{t('aboutUs.services.legal.paragraph')}</Text>
      ),
    },
  ]
}
